import * as React from 'react';
import EventService from '../CalculationComponents/calculationComponents.eventservice';

export interface StatsbidragFormMenuControllerProps {
  canUserSave: boolean;
}

/**
 * Let's the StatsbidragFormMenu whether the current user has permission to save the form data. 
 */
export class StatsbidragFormMenuController extends React.PureComponent<StatsbidragFormMenuControllerProps> {
  constructor(props: StatsbidragFormMenuControllerProps) {
    super(props);
  }

  componentDidMount = () => {
    EventService.fire('FORMMENU_SAVEBUTTON_STATE', { detail: this.props.canUserSave });
  };

  public render() {
    return null;
  }
}
